import { render, staticRenderFns } from "./PointTreeTest.vue?vue&type=template&id=6c08aeba&scoped=true"
import script from "./PointTreeTest.vue?vue&type=script&lang=js"
export * from "./PointTreeTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08aeba",
  null
  
)

export default component.exports